<template>
  <b-container>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>    
    <h1>script</h1>
    <router-link :to="'/checklist/predefinedScript/list'">
    <b-button class="mb-4"  size="sm">
          {{ $t("geral.back") }}
        </b-button>
    </router-link>

    <predefined-script-crud :model.sync="model"></predefined-script-crud>

    <b-button class="mt-4 ml-3" :disabled="submitted" @click="save()"
      >Salvar</b-button
    >
  </b-container>
</template>
<script>
export default {
  props: {
    id: Number,
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    PredefinedScriptCrud: () =>
      import(
        "@/components_rms/checklist/PredefinedScripts/PredefinedScriptCrud.vue"
      ),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Script salvo com sucesso",
      },
      submitted: false,
      model: {
        name: "",
        description: "",
        active: true,
        script: "",
        scriptType: 0,
        variables: [],
      },
    };
  },
  created() {
    if (this.id) {
      this.loadData();
    }
  },
  methods: {
    loadData(){
      this.$apiChecklist
          .get("/predefinedScript/getById/" + this.id)
          .then((response) => {
            console.log("Response")
            console.log(response);
            this.model = response.data;
          })
          .catch((error) => {
            this.form = {};
            this.fieldSearchKey = this.getFormSearchKeyField();
            this.scheduler.fieldSearchKeyId = 0;
            this.scheduler.valuesToSchedule = [];

            console.log("Error to load data on EditForm");
            console.log(error);
            console.log(error.response.data.errors);

            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
            }
          });
    },
    save() {
      this.submitted = true;

      this.$apiChecklist
        .post("/predefinedScript/save", this.model)
        .then((response) => {
          this.$refs.alert.show();
          this.submitted = false;
        })
        .catch((error) => {
          this.submitted = false;
          this.modelstate = {};

          if (error.response) {
            console.log(error.response);
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = error.message;
              this.$refs.danger.show();
            } else if (error.response.status == 500) {
              this.alert.error = error.response.data;
              this.$refs.danger.show();
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
};
</script>
